import { createContext, use } from "react";

interface IFloatingControlContext {
	/**
	 * The node a panel portals into, or null before it exists. State rather than a ref on
	 * purpose: a ref is still null while the consumer first renders, and nothing would re-render
	 * it once the node attached — the panel would portal itself to the end of the document and
	 * stay there.
	 */
	container: HTMLDivElement | null;
}

export const FloatingControlContext = createContext<IFloatingControlContext>({ container: null });

export function useFloatingControlContext() {
	return use(FloatingControlContext);
}
